// Bộ nhãn đọc TRỰC TIẾP từ nhan.yml (một nguồn sự thật — như bản v1).
import type { NhanDinhNghia } from './kieu';

export type BoNhan = Record<string, NhanDinhNghia[]>;

export function phanTichNhanYml(yml: string): BoNhan {
  const nhom: BoNhan = {};
  const re = /-\s+ten:\s+"([^"]+)"\s*\n\s+mau:\s+"([^"]+)"\s*(?:\n\s+mo_ta:\s+"([^"]*)")?/g;
  let m: RegExpExecArray | null;
  while ((m = re.exec(yml)) !== null) {
    const [, ten, mau, mo_ta] = m;
    const truc = ten.includes(':') ? ten.split(':')[0] : '_khac';
    (nhom[truc] ||= []).push({ ten, mau, mo_ta: mo_ta || '' });
  }
  return nhom;
}

export const duoi = (ten: string) => ten.slice(ten.indexOf(':') + 1);

// Tag tự do → slug không dấu, chữ thường, gạch nối (cùng quy ước với nhan.yml: nhãn có dấu hỏng ở
// một số connector). "Khẩn cấp" và "khan cap" ra cùng một tag — chặn nạn tag gần giống nhau.
export function slugTag(van_ban: string): string {
  return van_ban
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40);
}

// So khớp không dấu cho tìm kiếm ("nguyen" khớp "Nguyễn").
export const boDau = (s: string) => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D').toLowerCase();
